module.exports = __webpack_public_path__ + "assets/smart-asset-instagram.57c3f826.svg";